import { useCallback } from 'react';
import { useRouter } from 'expo-router';

export const useNavigatePostOrder = () => {
  const router = useRouter();

  const navigatePostOrder = useCallback(() => {
    router.dismissTo('/');
  }, [router]);

  return { navigatePostOrder };
};
